import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { timeout } from "rxjs/operators";
import { HomeService } from "../home.service";

@Component({
  selector: 'app-multipe-form-list',
  templateUrl: './multipe-form-list.component.html',
  styleUrls: ['./multipe-form-list.component.scss']
})
export class MultipeFormListComponent implements OnInit, OnDestroy {
  questionList = [];
  SectionList = [];
  forumData: any;
  totalQuestion: number = 0;
  totalFilled: number = 0;
  isSection: boolean = false;
  isLoading: boolean = false;
  isUploading:boolean=false;
  userId: any;
  formId:any;
  circleId:any;
  isFormEdited:any;
  interval:any;
  constructor(
    private _snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private homeService: HomeService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
      this.userId = param["userId"];
      this.formId = param["formId"];
      this.circleId = param["circleId"];
      this.isFormEdited = param["isFormSubmittedByMe"];
      if (param) {
          this.getUserFormEditedDetail();
      
      }
    });
    // this.interval = setInterval(() => {
    //   this.validateForum('');
    // }, 5000);
  }

  getActiveState(item) {
    this.questionList = item.response;
          if (this.questionList["0"]["sectionName"]) {
            this.isSection = true;
            this.SectionList = this.questionList;
          } else {
            this.isSection = false;
          }
    // this.validateForum('')
  }
  multiType:boolean = false
  getUserFormEditedDetail() {
    this.forumData  =[];
    this.isLoading = true
    let query = "?formId="+this.formId+"&userId="+this.userId;
    this.homeService.getUserFormEditedDetailApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.forumData = res.data.formResponseList;
       
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }


  ngOnDestroy() {
    localStorage.removeItem("question");
  }
  validateForum(event: any) {
    
    this.totalFilled = 0;
    this.totalQuestion = 0;
    for (let i = 0; i < this.questionList.length; i++) {
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "checkbox"
      ) {
        this.questionList[i]["values"].forEach((element) => {
          if (element["valueSelect"] == true) {
            this.totalFilled = this.totalFilled + 1;
          }
        });
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "text"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "radio"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "singleSelect"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (this.questionList[i]["isRequired"] == true) {
        this.totalQuestion = this.totalQuestion + 1;
      }
    }
  }
  totalFilledSecondary: number = 0;
  totalQuestionSecondary: number = 0;
  validateSeconday(event: any) {
    this.totalFilledSecondary = 0;
    this.totalQuestionSecondary = 0;
    for (let i = 0; i < this.questionList.length; i++) {
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "radio"
      ) {
        this.questionList[i]["values"].forEach((element) => {
          if (element["isLevel"] == true) {
            if (element["questions"]["isRequired"] == true) {
              this.totalQuestionSecondary = this.totalQuestionSecondary + 1;
            }
            if (element["questions"]["isRequired"] == true) {
              this.totalQuestionSecondary = this.totalQuestionSecondary + 1;
            }
          }
        });
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "singleSelect"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (this.questionList[i]["isRequired"] == true) {
        this.totalQuestion = this.totalQuestion + 1;
      }
    }
  }

  submitForm() {
    if (this.totalQuestion !== this.totalFilled) {
      return this._snackBar.open("Please fill all mandatory fields", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["success"],
      });
    } else {
      let req = {};
      if(this.isSection == false) {
        req['response'] = this.questionList;

        req['questions'] = [{"name":'h1'}];
      } else {
        req['response'] = this.SectionList;
        req['questions'] = [{"name":'h1'}];
      } 
      req['formId']=this.formId;
      this.isLoading = true
        this.homeService.submitMultipleTypeForm(req).subscribe(
          (res) => {
            this.isLoading = false;
            if ((res["message"] = "Success")) {
              this.router.navigate(["/main/circles/circle-profile/circle-members"],{ queryParams: { ownerId:this.userId,id:this.circleId}, preserveQueryParams: false });
              return this._snackBar.open("Form submitted successfully !", "", {
                duration: 3000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["success"],
              });
             
            } else {
              this.isLoading = false;
            }
          },
          (err) => {
            this.isLoading = false;
          }
        );
    }

  }

  formEditSumbit () {
        if (this.totalQuestion !== this.totalFilled) {
          return this._snackBar.open("Please fill all mandatory fields", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        } else {
          let req = {};
          if(this.isSection == false) {
            req['response'] = this.questionList;
            req['questions'] = [{"name":'h1'}];
          } else {
            req['response'] = this.SectionList;
            req['questions'] = [{"name":'h1'}];
          } 
          req['formResponseId'] = this.forumData.formResponseId;
          this.isLoading = true
            this.homeService.submitSingleTypeForm(req).subscribe(
              (res) => {
                this.isLoading = false;
                if ((res["message"] = "Success")) {
                  this.router.navigate(["/main/circles/circle-profile/circle-members"],{ queryParams: { ownerId:this.userId,id:this.circleId}, preserveQueryParams: false });
                  return this._snackBar.open("Form submitted successfully !", "", {
                    duration: 3000,
                    horizontalPosition: "right",
                    verticalPosition: "top",
                    panelClass: ["success"],
                  });
                 
                } else {
                  this.isLoading = false;
                }
              },
              (err) => {
                this.isLoading = false;
              }
            );
        }
  }

  navigateBAck(){
    this.router.navigate(["/main/circles/circle-profile/circle-members"],{ queryParams: { ownerId:this.userId,id:this.circleId}, preserveQueryParams: false });
            
  }
  isEdit:boolean = false;
  navigateEdit(accordionIndex,item){
    if(this.forumData[accordionIndex]['isShow'] == false) {
      this.forumData[accordionIndex]['isShow'] = true;
    } else {
      this.forumData[accordionIndex]['isShow'] = false;
    }
  }

  
  
  url = "";
  selectedFile: File;
  uploadAttachment(event,index) {
    this.selectedFile = null;
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    this.homeService.uploadImage(this.selectedFile).subscribe(
      res => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.isUploading = true;
          this.url = res['data'].url;
          this.questionList[index]['valuesText'] = res.data.url;
          setTimeout(() => {
            /** spinner ends after 1 seconds */
            this.isUploading = false;
          }, 1000);

        } else {
        }
      },
      err => {
        this.isLoading = false;
      }
    );
  }
  uploadAttachment1(event,Sectionindex,QuestionIndex) {
    this.selectedFile = null;
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    this.homeService.uploadImage(this.selectedFile).subscribe(
      res => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.isUploading = true;
          this.url = res['data'].url;
          this.SectionList[Sectionindex]['questions'][QuestionIndex]['valuesText'] = res.data.url;
          setTimeout(() => {
            /** spinner ends after 1 seconds */
            this.isUploading = false;
          }, 1000);

        } else {
        }
      },
      err => {
        this.isLoading = false;
      }
    );
  }
  openwebView(value) {
    let index =value.indexOf('http');
    let url  = '';
    if (index == -1) {
         url = 'http://' + value ;
    }
    else 
    {
        url = value ;
    }
    window.open(url, "_blank");
  }
  
  navigateToEditUserForm(item,value) {
      this.router.navigate(["/main/edit-user-multiple-form"],{ queryParams: {userId:this.userId,formId:item.formId,circleId:this.circleId,formResponseId:item.formResponseId}, preserveQueryParams: false });
  }
  navigateToFillForm() {
    this.router.navigate(["/main/fill-form"],{ queryParams: {userId:this.userId,formId:this.formId,circleId:this.circleId,from:"multi",isFormSubmittedByMe:"false"}, preserveQueryParams: false });
  }
}
